export const fontOptions = [
  {
    value: 'arial',
    label: 'Arial',
  },
  {
    value: 'inter',
    label: 'Inter',
  },
  {
    value: 'roboto',
    label: 'Roboto',
  },
  {
    value: 'times New Roman',
    label: 'Times New Roman',
  },
];
export const sizeOptions = [
  {
    value: 'default',
    label: 'Default',
  },
  {
    value: 'compact',
    label: 'Compact',
  },
  {
    value: 'comfortable',
    label: 'Comfortable',
  },
];
export const buttonShapeOptions = [
  {
    value: 'rounded',
    label: 'Rounded',
  },
  {
    value: 'square',
    label: 'Square',
  },
];

export const dockedAlignmentOptions = [
  {
    value: 'right',
    label: 'Right',
  },
  {
    value: 'left',
    label: 'Left',
  },
];

// Define font size mappings for small, default, and large
export const fontSizes = {
  compact: {
    '--cometchat-font-title-bold': '700 26px/31.2px var(--cometchat-font-family)',
    '--cometchat-font-title-medium': '500 26px/31.2px var(--cometchat-font-family)',
    '--cometchat-font-title-regular': '400 26px/31.2px var(--cometchat-font-family)',

    '--cometchat-font-heading1-bold': '700 20px/24px var(--cometchat-font-family)',
    '--cometchat-font-heading1-medium': '500 20px/24px var(--cometchat-font-family)',
    '--cometchat-font-heading1-regular': '400 20px/24px var(--cometchat-font-family)',

    '--cometchat-font-heading2-bold': '700 18px/21.6px var(--cometchat-font-family)',
    '--cometchat-font-heading2-medium': '500 18px/21.6px var(--cometchat-font-family)',
    '--cometchat-font-heading2-regular': '400 18px/21.6px var(--cometchat-font-family)',

    '--cometchat-font-heading3-bold': '700 16px/19.2px var(--cometchat-font-family)',
    '--cometchat-font-heading3-medium': '500 16px/19.2px var(--cometchat-font-family)',
    '--cometchat-font-heading3-regular': '400 16px/19.2px var(--cometchat-font-family)',

    '--cometchat-font-heading4-bold': '700 14px/16.8px var(--cometchat-font-family)',
    '--cometchat-font-heading4-medium': '500 14px/16.8px var(--cometchat-font-family)',
    '--cometchat-font-heading4-regular': '400 14px/16.8px var(--cometchat-font-family)',

    '--cometchat-font-body-bold': '700 12px/14.4px var(--cometchat-font-family)',
    '--cometchat-font-body-medium': '500 12px/14.4px var(--cometchat-font-family)',
    '--cometchat-font-body-regular': '400 12px/14.4px var(--cometchat-font-family)',

    '--cometchat-font-caption1-bold': '700 10px/12px var(--cometchat-font-family)',
    '--cometchat-font-caption1-medium': '500 10px/12px var(--cometchat-font-family)',
    '--cometchat-font-caption1-regular': '400 10px/12px var(--cometchat-font-family)',

    '--cometchat-font-caption2-bold': '700 9px/10.8px var(--cometchat-font-family)',
    '--cometchat-font-caption2-medium': '500 9px/10.8px var(--cometchat-font-family)',
    '--cometchat-font-caption2-regular': '400 9px/10.8px var(--cometchat-font-family)',

    '--cometchat-font-button-bold': '700 12px/14.4px var(--cometchat-font-family)',
    '--cometchat-font-button-medium': '500 12px/14.4px var(--cometchat-font-family)',
    '--cometchat-font-button-regular': '400 12px/14.4px var(--cometchat-font-family)',

    '--cometchat-font-link': '400 12px/14.4px var(--cometchat-font-family)',
  },
  default: {
    '--cometchat-font-title-bold': '700 32px/38.4px var(--cometchat-font-family)',
    '--cometchat-font-title-medium': '500 32px/38.4px var(--cometchat-font-family)',
    '--cometchat-font-title-regular': '400 32px/38.4px var(--cometchat-font-family)',

    '--cometchat-font-heading1-bold': '700 24px/28.8px var(--cometchat-font-family)',
    '--cometchat-font-heading1-medium': '500 24px/28.8px var(--cometchat-font-family)',
    '--cometchat-font-heading1-regular': '400 24px/28.8px var(--cometchat-font-family)',

    '--cometchat-font-heading2-bold': '700 20px/24px var(--cometchat-font-family)',
    '--cometchat-font-heading2-medium': '500 20px/24px var(--cometchat-font-family)',
    '--cometchat-font-heading2-regular': '400 20px/24px var(--cometchat-font-family)',

    '--cometchat-font-heading3-bold': '700 18px/21.6px var(--cometchat-font-family)',
    '--cometchat-font-heading3-medium': '500 18px/21.6px var(--cometchat-font-family)',
    '--cometchat-font-heading3-regular': '400 18px/21.6px var(--cometchat-font-family)',

    '--cometchat-font-heading4-bold': '700 16px/19.2px var(--cometchat-font-family)',
    '--cometchat-font-heading4-medium': '500 16px/19.2px var(--cometchat-font-family)',
    '--cometchat-font-heading4-regular': '400 16px/19.2px var(--cometchat-font-family)',

    '--cometchat-font-body-bold': '700 14px/16.8px var(--cometchat-font-family)',
    '--cometchat-font-body-medium': '500 14px/16.8px var(--cometchat-font-family)',
    '--cometchat-font-body-regular': '400 14px/16.8px var(--cometchat-font-family)',

    '--cometchat-font-caption1-bold': '700 12px/14.4px var(--cometchat-font-family)',
    '--cometchat-font-caption1-medium': '500 12px/14.4px var(--cometchat-font-family)',
    '--cometchat-font-caption1-regular': '400 12px/14.4px var(--cometchat-font-family)',

    '--cometchat-font-caption2-bold': '700 10px/12px var(--cometchat-font-family)',
    '--cometchat-font-caption2-medium': '500 10px/12px var(--cometchat-font-family)',
    '--cometchat-font-caption2-regular': '400 10px/12px var(--cometchat-font-family)',

    '--cometchat-font-button-bold': '700 14px/16.8px var(--cometchat-font-family)',
    '--cometchat-font-button-medium': '500 14px/16.8px var(--cometchat-font-family)',
    '--cometchat-font-button-regular': '400 14px/16.8px var(--cometchat-font-family)',

    '--cometchat-font-link': '400 14px/19.6px var(--cometchat-font-family)',
  },
  comfortable: {
    '--cometchat-font-title-bold': '700 36px/43.2px var(--cometchat-font-family)',
    '--cometchat-font-title-medium': '500 36px/43.2px var(--cometchat-font-family)',
    '--cometchat-font-title-regular': '400 36px/43.2px var(--cometchat-font-family)',

    '--cometchat-font-heading1-bold': '700 28px/33.6px var(--cometchat-font-family)',
    '--cometchat-font-heading1-medium': '500 28px/33.6px var(--cometchat-font-family)',
    '--cometchat-font-heading1-regular': '400 28px/33.6px var(--cometchat-font-family)',

    '--cometchat-font-heading2-bold': '700 24px/28.8px var(--cometchat-font-family)',
    '--cometchat-font-heading2-medium': '500 24px/28.8px var(--cometchat-font-family)',
    '--cometchat-font-heading2-regular': '400 24px/28.8px var(--cometchat-font-family)',

    '--cometchat-font-heading3-bold': '700 20px/24px var(--cometchat-font-family)',
    '--cometchat-font-heading3-medium': '500 20px/24px var(--cometchat-font-family)',
    '--cometchat-font-heading3-regular': '400 20px/24px var(--cometchat-font-family)',

    '--cometchat-font-heading4-bold': '700 18px/21.6px var(--cometchat-font-family)',
    '--cometchat-font-heading4-medium': '500 18px/21.6px var(--cometchat-font-family)',
    '--cometchat-font-heading4-regular': '400 18px/21.6px var(--cometchat-font-family)',

    '--cometchat-font-body-bold': '700 16px/19.2px var(--cometchat-font-family)',
    '--cometchat-font-body-medium': '500 16px/19.2px var(--cometchat-font-family)',
    '--cometchat-font-body-regular': '400 16px/19.2px var(--cometchat-font-family)',

    '--cometchat-font-caption1-bold': '700 14px/16.8px var(--cometchat-font-family)',
    '--cometchat-font-caption1-medium': '500 14px/16.8px var(--cometchat-font-family)',
    '--cometchat-font-caption1-regular': '400 14px/16.8px var(--cometchat-font-family)',

    '--cometchat-font-caption2-bold': '700 12px/14.4px var(--cometchat-font-family)',
    '--cometchat-font-caption2-medium': '500 12px/14.4px var(--cometchat-font-family)',
    '--cometchat-font-caption2-regular': '400 12px/14.4px var(--cometchat-font-family)',

    '--cometchat-font-button-bold': '700 16px/19.2px var(--cometchat-font-family)',
    '--cometchat-font-button-medium': '500 16px/19.2px var(--cometchat-font-family)',
    '--cometchat-font-button-regular': '400 16px/19.2px var(--cometchat-font-family)',

    '--cometchat-font-link': '400 16px/19.6px var(--cometchat-font-family)',
  },
};
